const BASE_URL = process.env.REACT_APP_BASE_QS_URL;

export const ApiRequestInterceptorQS = async (path, method, body, header = {}) => {
    try {
        const params = ApiRequestParamsFormatterQS(method, body, header);
        const response = await fetch(`${BASE_URL}/${path}`, params);
        return ApiRequestFormatterQS(response);
    } catch (exception) {
        //TODO Handle Exception Pendient
        return {
            error: 500,
            data: null,
        };
    } finally {
        //TODO Handle Loading
    }
};

const ApiRequestParamsFormatterQS = (method, body, header) => {
    const headers = ApiRequestHeaderFormatterQS(header);

    return method !== "GET" && body
        ? {
            method,
            body: JSON.stringify(body),
            headers,
        }
        : { method, headers };
};

const ApiRequestFormatterQS = async (response) => {
    const code = response.status;
    let data = null;

    if (
        response.headers.get("content-type")?.includes("application/json")
    ) {
        try {
            data = await response.json();
        } catch (e) {
            data = null;
        }
    }

    return { code, data };
};


const ApiRequestHeaderFormatterQS = (header) => {
    let headers = new Headers();

    for (const key in header) {
        headers.append(key, header[key]);
        headers.append("Content-Type", "application/json");
    }

    return headers;
};
